import { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const useSessions = (race) => {
  const [state, setState] = useState({
    status: 'idle',
    sessions: [],
    latestCode: null,
  });

  useEffect(() => {
    if (!race) {
      setState({ status: 'idle', sessions: [], latestCode: null });
      return;
    }
    let cancelled = false;
    setState({ status: 'loading', sessions: [], latestCode: null });
    (async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/sessions?race=${encodeURIComponent(race)}`,
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const body = await res.json();
        if (cancelled) return;
        setState({
          status: 'ready',
          sessions: body.sessions || [],
          latestCode: body.latestCode || null,
        });
      } catch (err) {
        console.error('Failed to load sessions:', err);
        if (!cancelled) {
          setState({ status: 'error', sessions: [], latestCode: null });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [race]);

  return state;
};
